import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import ToolTip from "@material-ui/core/Tooltip";
import Add from "@material-ui/icons/Add";
import get from "lodash/get";
import React from "react";
import Dropzone from "react-dropzone";
import ArrowBack from "@material-ui/icons/ArrowBack";
import Select from "react-select";
import loader from "Assets/Gif/loader.gif";
import { instance, instanceMultipart } from "../../../../../../Actions/AxiosInstance";
import cancelIcon from "../../../../../../Assets/Svg/cancel.svg";
import {getUrlExtension } from "../../../../../../Handlers/getters";
// import { getFormattedImageLink } from "../../../../../Utils";
import Configs from "../../../../../../Constants/Configs";
import documentIcon from "../../../../../../Assets/Svg/document-icon.svg";
import walletIcon from "../../../../../../Assets/Svg/wallet.svg";
import DynamicForm, { fetchMyForm } from "../../../../../../Component/DynamicForm";
import "../../../../../../Component/Navigation/Navigation.css";
import { getFormattedDate} from "../../../../../../Utils";
import { apioutputconverter, inputconverter, outputconverter } from "./functions";
import "./index.css";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import moment from "moment";

const getSubExpenseTypeOptions = ({ categories }) => {
  const subcategories = [];
  categories.forEach((category) => {
    category.subcategory
    && category.subcategory.forEach((subcategory) => {
        subcategories.push({
          isfuelconfig: subcategory.isfuelconfig,
          subexpensecategoryid: category.subexpensecategoryid,
          subexpensesubcategoryid: subcategory.subexpensesubcategoryid,
          subcategoryname: subcategory.subcategoryname,
        });
      });
  });

  return subcategories || [];
};

let errmsg1 = '';

export default class ClaimRequest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      claimPolicy: null,
      selectedSubCategory: null,
      afteradd: false,
      selectedcurrency: null,
      currencyconversionlogid: "",
      currencyList: [],
      postdata: {
        "currencyconversionlogid": null,
        "conversionrate": null,
        expensepolicyid: null,
        expenserequesttypeid: 1,
        comment: "",
        sendersourceid: 1,
        totalamount: null,
        expenserequestdetail: [],
      },
      copydata: {
        expensepolicyid: null,
        "currencyconversionlogid": null,
        "conversionrate": null,
        expenserequesttypeid: 1,
        comment: "",
        sendersourceid: 1,
        totalamount: null,
        expenserequestdetail: [],
      },
      recipient: null,
      selectedcount: 1,
      isSendRequestBtn: true,
    };

    this.onSelectSubCategory = this.onSelectSubCategory.bind(this);
    this.getFields = this.getFields.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.removeImg = this.removeImg.bind(this);
    this.onAdd = this.onAdd.bind(this);
    this.getFormattedImageLink = this.getFormattedImageLink.bind(this);
    this.onDeleteExpenseDetails = this.onDeleteExpenseDetails.bind(this);
    this.getSubCategory = this.getSubCategory.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  componentDidMount() {
    this.getCurrency();
    // this.getClaimPolicy();
  }

  getCurrency() {
    instance
    .get(`subscription/getcurrencyconversionlist`)
    .then((result) => {
      this.setState({
        currencyList: result.data.result.map((x) => ({
          displayvalue: x.currencyconversionlogid,
          displayname: x.currencyacronym,
          ...x,
        })),
      });
    })
    .catch((error) => {
      const msg =
        error && error.response && error.response.data.error.message;
      // this.props.enqueueSnackbar(msg, {
      //   variant: "error",
      // });
    });
  }

  handleChange(value, key) {
    const selectedcurrency = this.state.currencyList.find((x) => x[key] == value);
    this.setState({
      [key]: value,
      loader: true,
      selectedcurrency,
      postdata: { ...this.state.postdata, currencyconversionlogid: value, conversionrate: selectedcurrency ? selectedcurrency.conversionrate : null },
      copydata: { ...this.state.copydata, currencyconversionlogid: value, conversionrate: selectedcurrency ? selectedcurrency.conversionrate : null },
    }, () => {
      this.getClaimPolicy();
    });
  }

  getClaimPolicy() {
    const { SelectedEmpData } = this.props;
    instance
      .post(
        `requestcenter/initexpenserequest`, {
          "currencyconversionlogid": this.state.currencyconversionlogid,
          employeeid: SelectedEmpData ? SelectedEmpData.displayvalue : null,
        },
      )
      .then((result) => {
        const { postdata } = this.state;
        postdata.expensepolicyid = result.data.result[0].expensepolicyid;
        const { copydata } = this.state;
        postdata.expensepolicyid = result.data.result[0].expensepolicyid;
        this.setState({
          claimPolicy: result.data.result[0],
          copydata,
          postdata,
          loader: false
        });
      })
      .catch((error) => {
        this.setState({
          loader: false
        });
        const msg =
          error && error.response && error.response.data.error.message;
        // this.props.enqueueSnackbar(msg, {
        //   variant: "error",
        // });
      });
  }

  // componentWillReceiveProps(props) {
  //   this.setState({
  //     claimPolicy: props.claimPolicy,
  //   });
  // }

  GetApproverList() {
    const data = {
      workflowfortypeid: 5,
      withadmin: true,
      employeeid: this.props.employeeid || this.props.AuthenticationAction.login.employeeid,
    };
    instance
      .post("leaves/employeeapprovalrecipients", data)
      .then((result) => {
        let recipient = [];
        for (const approver of result.data.result) {
          const approverObj = {
            approveremployeeid: approver.employeeid,
            levelid: approver.levelid,
          };
          recipient.push(approverObj);
        }
        if (recipient.length < 0) recipient = null;
        this.setState({ recipient });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(error.response ? error.response.data.error.message : error.message, { variant: "error" });
      });
  }

  getFields(selectedSubCategory) {
    const { subexpensecategoryid, subexpensesubcategoryid } = selectedSubCategory;
    const { postdata } = this.state;
    const {
      claimPolicy: { expensepolicyid },
    } = this.state;
    let count = 1;
    this.setState({
      afteradd: false,
    }, () => {
      if (postdata.expenserequestdetail.length > 0) {
        count = parseInt(postdata.expenserequestdetail[postdata.expenserequestdetail.length - 1].count) + 1;
      } else {
        count = 1;
      }
      postdata.expenserequestdetail.push({
        isvalid: false,
        count,
        isfuelconfig: selectedSubCategory.isfuelconfig,
        subexpensecategoryid: selectedSubCategory.subexpensecategoryid,
        subexpensesubcategoryid: selectedSubCategory.subexpensesubcategoryid,
        subcategoryname: selectedSubCategory.subcategoryname,
        attachmenturl: [],
        expenserequestfield: [],
      });
      const index = postdata.expenserequestdetail.findIndex((x) => x.count == count);
      instance
        .get(`requestcenter/subexpensefield/${expensepolicyid}/${subexpensecategoryid}/${subexpensesubcategoryid}`)
        .then((result) => {
          const { claimPolicy } = this.state;
          if (claimPolicy) {
            const mindate = claimPolicy.cycle.previous
            ? this.props.doj > claimPolicy.cycle.previous.cyclestartdate
            ? this.props.doj : claimPolicy.cycle.previous.cyclestartdate
            : this.props.doj > claimPolicy.cycle.current.cyclestartdate
            ? this.props.doj : claimPolicy.cycle.current.cyclestartdate;

            const maxrequestdate = claimPolicy.cycle.previous ? claimPolicy.cycle.previous.maxrequestapplydate : claimPolicy.cycle.current.maxrequestapplydate;
            const parts = mindate.split('-');
            const data = result.data.result.map((field) => {
              if (field.defaultfieldtypeid == 1) {
                const obj = field;
                obj.min = new Date(parts[0], parts[1] - 1, parts[2]);
                obj.max = new Date();
                obj.maxrequestdate = maxrequestdate;
                return obj;
              }
              if (field.fielddatatypid == 2) {
                const obj = field;
                obj.min = new Date(parts[0], parts[1] - 1, parts[2]);
                obj.max = new Date();
                return obj;
              }
              if (field.defaultfieldtypeid == 2) {
                const obj = field;
                obj.min = 1;
                return obj;
              }
              return field;
            });

            postdata.expenserequestdetail[index].expenserequestfield = data;
            this.setState({
              postdata,
              selectedSubCategory,
              selectedcount: count,
              afteradd: true,
              loader: false
            });
          }
        })
        .catch((error) => {
          const msg = error && error.response && error.response.data.error.message;
          this.props.enqueueSnackbar(msg, {
            variant: "error",
          });
          this.setState({
            loader: false
          })
        });
    });
  }

  onSelectSubCategory(selectedSubCategory) {
    let valid = true;
    if (this.state.postdata.expenserequestdetail.length > 0) {
      valid = this.state.postdata.expenserequestdetail[this.state.postdata.expenserequestdetail.length - 1].isvalid;
    }
    if (valid) {
      this.setState({
        loader: true,
      })
      this.getFields(selectedSubCategory);
      this.GetApproverList();
    } else {
      this.props.enqueueSnackbar("Please add/delete selected expense type before selecting another", { variant: "error" });
    }
  }

  getFiles1(files) {
    const { subexpensesubcategoryid } = this.state.selectedSubCategory;
    const { postdata, selectedcount } = this.state;
    if (subexpensesubcategoryid) {
      const index = postdata.expenserequestdetail.findIndex((x) => x.count == selectedcount);
      const file = files[0];
      const formData = new FormData();
      // if (get(this.props, "AuthenticationAction.IsFulfilled", "")) {
      //   formData.append("file", file);
      // } else {
      //   formData.append("file", file);
      // }

      formData.append("file", file);

      if (files.length == 0) {
        this.props.enqueueSnackbar("Please select Valid image. (Maxsize : 2MB)", {
          variant: "error",
        });
        return false;
      }
      instanceMultipart.post("expense/uploadrequestattachment", formData).then((resp) => {
        postdata.expenserequestdetail[index].attachmenturl.push(resp.data.result[0].imagepath);
        this.setState({ postdata });
      });
    }
  }

  getSubCategory(selectedSubCategory) {
    this.setState({
      selectedSubCategory,
      selectedcount: selectedSubCategory.count,
      afteradd: true,
    });
  }

  removeImg(index) {
    const { postdata, selectedSubCategory, selectedcount } = this.state;
    if (selectedSubCategory) {
      const { subexpensesubcategoryid } = selectedSubCategory;
      if (subexpensesubcategoryid) {
        const exindex = postdata.expenserequestdetail.findIndex((x) => x.count == selectedcount);
        postdata.expenserequestdetail[exindex].attachmenturl.splice(index, 1);
        this.setState({ postdata });
      }
    }
  }

  onAdd(flag) {
    errmsg1 = '';
    if (flag == "delete") {
      this.props.enqueueSnackbar("You will loss this data, Are you sure you want to cancel this?", {
        variant: "warning",
        action: [
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={this.onDeleteExpenseDetails}
          >
            Yes
          </Button>,
          <Button key="key" color="inherit" size="small" onClick={() => this.props.closeSnackbar()}>
            No
          </Button>,
        ],
      });
    } else if (this.state.selectedcurrency == null) {
        this.props.enqueueSnackbar("Please select a currency before adding an expense!", {
          variant: "error",
        });
        return;
    } else if (!flag) {
      const { postdata, selectedSubCategory, claimPolicy, selectedcount } = this.state;
      if (selectedSubCategory) {
        const { subexpensesubcategoryid } = selectedSubCategory;
        if (subexpensesubcategoryid) {
          const form = fetchMyForm(selectedcount);
          let isvalid = true;
          let validattach = true;
          if (form.fields && !form.fields.find((field) => field.defaultfieldtypeid == 5)) {
            if (form.fields && form.fields.find((field) => field.defaultfieldtypeid == 2)) {
              const amount = form.fields.find((field) => field.defaultfieldtypeid == 2);
              if (claimPolicy && claimPolicy.isreceiptnotrequire) {
                if (parseInt(amount.value) > parseInt(claimPolicy.receiptmaxamount)) {
                  validattach = false;
                }
              } else if (claimPolicy && !claimPolicy.isreceiptnotrequire) {
                validattach = true;
              }
            }
          } else {
            validattach = true;
          }
          // setDynamicForm
          const cat = claimPolicy && claimPolicy.category.find((category) => category.subexpensecategoryid == selectedSubCategory.subexpensecategoryid);
          if (cat) {
            const index = postdata.expenserequestdetail.findIndex((x) => x.count == selectedcount);
            if (claimPolicy && !claimPolicy.isreceiptnotrequire) {
              if (postdata.expenserequestdetail[index].attachmenturl && postdata.expenserequestdetail[index].attachmenturl.length < 1) {
                this.props.enqueueSnackbar("Please add at least one attachments", {
                  variant: "error",
                });
                isvalid = false;
                return;
              }
            } else if (claimPolicy && claimPolicy.isreceiptnotrequire) {
              if (!validattach) {
                if (postdata.expenserequestdetail[index].attachmenturl && postdata.expenserequestdetail[index].attachmenturl.length < 1) {
                  this.props.enqueueSnackbar("Please add at least one attachments", {
                    variant: "error",
                  });
                  isvalid = false;
                  return;
                }
              }
            }
            
            const updatedFields = get(form, "fields", []).map((fld) => ({
              ...fld,
              showAllErr: true,
            }));
            let errmsg = "";
            updatedFields.forEach((field) => {
              if (field.iserr({ fielddata: field }) === true) {
                if (field.errorText != "Please fill required field") {
                  // this.props.enqueueSnackbar(field.errorText, { variant: "error" });
                  isvalid = false;
                } else {
                  errmsg = "Please fill required field";
                  isvalid = false;
                }
              }
            });
            // const maxrequestdate = claimPolicy.cycle.previous ? claimPolicy.cycle.previous.maxrequestapplydate : claimPolicy.cycle.current.maxrequestapplydate;
            const objBillDate = updatedFields.find((fil) => fil.defaultfieldtypeid == 1);
            const expenseBillDate = moment(objBillDate.value).format("YYYY-MM-DD");
            const today = moment(new Date()).format("YYYY-MM-DD");
            if (objBillDate.value) {
              if (claimPolicy.cycle.previous && claimPolicy.cycle.previous.cyclestartdate <= expenseBillDate && expenseBillDate <= claimPolicy.cycle.previous.cycleenddate) {
                if (today > claimPolicy.cycle.previous.maxrequestapplydate) {
                  this.props.enqueueSnackbar("You've exceed the maximum days beyond which you can apply the request for the previous cycle.", {
                    variant: "error",
                  });
                  isvalid = false;
                  return;
                }
              } else if (claimPolicy.cycle.current.cyclestartdate <= expenseBillDate && expenseBillDate <= claimPolicy.cycle.current.cycleenddate) {
                if (today > claimPolicy.cycle.current.maxrequestapplydate) {
                  this.props.enqueueSnackbar("You've exceed the maximum days beyond which you can apply the request for the previous cycle.", {
                    variant: "error",
                  });
                  isvalid = false;
                  return;
                }
              } else {
                this.props.enqueueSnackbar("You've exceed the maximum days beyond which you can apply the request for the previous cycle.", {
                  variant: "error",
                });
                isvalid = false;
                return;
              }
            }

            // if (moment(new Date()).format("YYYY-MM-DD") > maxrequestdate) {
            //   this.props.enqueueSnackbar("Expense apply date is exceed", {
            //     variant: "error",
            //   });
            //   isvalid = false;
            //   return;
            // }
            if (errmsg != "") {
              this.props.enqueueSnackbar(errmsg, { variant: "error" });
            }
            if (isvalid) {
              postdata.expenserequestdetail[index].isvalid = true;
              postdata.expenserequestdetail[index].expenserequestfield = outputconverter(get(form, "fields", []));
              const { copydata } = this.state;
              copydata.expenserequestdetail.push(postdata.expenserequestdetail[index]);
              this.setState({
                afteradd: flag,
                postdata,
                copydata,
              });
              isvalid = false;
            } else {
              const RESULT = get(this.props, "DynamicForm.forms", []).map((forminstance) => ({
                ...forminstance,
                fields: forminstance.formKey == selectedcount ? updatedFields : forminstance.fields,
              }));
              this.props.setDynamicForm({ forms: RESULT });
            }
          }
        }
      } else {
        this.setState({
          selectedSubCategory: null,
          afteradd: flag,
        });
      }
    } else {
      this.setState({
        selectedSubCategory: null,
        afteradd: flag,
      });
    }
  }

  getFormattedImageLink(link) {
    const ext1 = getUrlExtension(link);
    // const ext1 = ext || getUrlExtension(docUrl);
    switch (ext1) {
      case "jpg":
      case "jpeg":
      case "png":
        return `${Configs.STORE_URL}${link}`;
      case "pdf":
      case "ppt":
      case "pptx":
      case "doc":
      case "docx":
      case "txt":
      case "text":
      case "rtf":
          case "odt":
        return documentIcon;
      default:
        return null;
    }
  };

  onDeleteExpenseDetails() {
    const { postdata, selectedSubCategory, selectedcount } = this.state;
    this.props.closeSnackbar();
    if (selectedSubCategory) {
      const { subexpensesubcategoryid } = selectedSubCategory;
      if (subexpensesubcategoryid) {
        const index = postdata.expenserequestdetail.findIndex((x) => x.count == selectedcount);
        postdata.expenserequestdetail.splice(index, 1);
        errmsg1 = '';
        this.setState({
          selectedSubCategory: null,
          postdata,
          afteradd: false,
        });
      }
    } else {
      this.setState({
        afteradd: false,
      });
    }
  }

  onSave() {
    const { postdata, selectedSubCategory} = this.state;
    this.setState({ isSendRequestBtn: false });
    const postdatacopy = JSON.stringify(postdata);
    const newreqdetail = postdata.expenserequestdetail.map((expensedetail) => {
      const object = expensedetail;
      delete object.subcategoryname;
      delete object.count;
      delete object.isvalid;
      if (object.attachmenturl.length == 0) {
        object.attachmenturl = null;
      }
      object.expenserequestfield = apioutputconverter(object.expenserequestfield);
      return object;
    });
    postdata.expenserequestdetail = newreqdetail;

    const x = [];
    postdata.expenserequestdetail.forEach((detail) => {
      detail.expenserequestfield.forEach((field) => {
        if (field.defaultfieldtypeid == 2) {
          x.push(field.fieldvalue);
        }
      });
    });

    const y = x.reduce((a, b) => parseInt(a) + parseInt(b), 0);
    postdata.totalamount = y;
    postdata.recipient = this.state.recipient;

    /**
     * * Check if recipeint exist
     */

    if(postdata.recipient && !postdata.recipient.length) {
      this.props.enqueueSnackbar(
        "No recipeint found for request",
        { variant: "error" }
      );
      return;
    }

    postdata.employeeid = this.props.isFromModule ? this.props.SelectedEmpData && this.props.SelectedEmpData.displayvalue : this.props.AuthenticationAction.login.employeeid;
    instance
      .post("requestcenter/createexpenserequest", postdata)
      .then(() => {
        this.setState({
          isSendRequestBtn: true,
          postdata: {
            expensepolicyid: this.state.claimPolicy && this.state.claimPolicy.expensepolicyid,
            expenserequesttypeid: 1,
            comment: "",
            sendersourceid: 1,
            totalamount: null,
            expenserequestdetail: [],
            "currencyconversionlogid": null,
            "conversionrate": null,
          },
          selectedSubCategory: null,
          afteradd: true,
        });
        this.props.enqueueSnackbar("Save successfully", {
          variant: "success",
        });
        errmsg1 = '';
        this.props.toggleDrawer({ drawerStatus: false, reqType: "", onsave: true });
      })
      .catch((error) => {
        const msg = error.response.data.error.message;
        errmsg1 = msg;
        const finaldata = JSON.parse(postdatacopy);
        finaldata.expenserequestdetail = finaldata.expenserequestdetail.map((detail) => {
          detail.expenserequestfield = detail.expenserequestfield.map((field) => {
            const obj = {
              ...field,
            };
            if (field.defaultfieldtypeid == 1 || field.fielddatatypid == 2) {
              obj.value = field.value ? moment(field.value).format("YYYY-MM-DD") : null;
              obj.min = field.min ? moment(field.min).format("YYYY-MM-DD") : null;
              obj.max = field.max ? moment(field.max).format("YYYY-MM-DD") : null;
              obj.fieldvalue = field.fieldvalue && field.fieldvalue[0] && field.fieldvalue[0].valuename ? [{
                valuename: moment(field.fieldvalue[0].valuename).format("YYYY-MM-DD"),
                subexpensefieldvalueid: "",
              }] : [{
                valuename: "",
                subexpensefieldvalueid: "",
              }];
            }
            return obj;
          });
          return detail;
        });
        this.setState({
          postdata: finaldata,
          selectedSubCategory,
          isSendRequestBtn: true
        });
        // this.props.enqueueSnackbar(msg, {
        //   variant: "error",
        // });
      });
  }

  render() {
    const { postdata, selectedSubCategory, claimPolicy, selectedcount } = this.state;
    let index = -1;
    let obj = null;
    let catobj = null;
    if (selectedSubCategory && claimPolicy) {
      if (selectedSubCategory.subexpensesubcategoryid) {
        index = postdata.expenserequestdetail.findIndex((x) => x.count == selectedcount);
        obj = postdata.expenserequestdetail.find((x) => x.count == selectedcount);
        console.log('obj: ', obj);
      }
      catobj = claimPolicy.category.find((cat) => cat.subexpensecategoryid == selectedSubCategory.subexpensecategoryid);
    }
    return (
      <div>
      { this.state.loader ?
       <img className="loader" src={loader} />
       : <div className="planner-right-drawer">
        {!this.state.afteradd && (
          <div className="" style={{ paddingBottom: 39 }}>
            <span className="drawer-close-btn" onClick={() => this.props.toggleDrawer({ drawerStatus: false, reqType: "" })}>
              <svg onClick={this.closeDrawer} width="24" height="24" viewBox="0 0 24 24">
                <path
                  d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7
              16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89
              4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
                />
              </svg>
            </span>
            <span className="drawer-header">Create new request</span>
          </div>
        )}
        {this.state.afteradd && (
          <div className="" style={{ paddingBottom: 24 }}>
            <span className="drawer-close-btn" style={{ float: "left", marginTop: 5 }} onClick={() => this.onAdd("delete")}>
              <ArrowBack />
            </span>
            <span className="drawer-header">Add expense</span>
          </div>
        )}
        {this.state.afteradd && (
          <Paper className="clear-float drawer-container" style={{ paddingLeft: 24, paddingRight: 24, background: "#f7f7f7" }}>
            <div className="drawer-input-group">
              <p className="input-label">Select expense category</p>
              <Select
                className="expense-cycle-input width100"
                placeholder="Select category"
                options={getSubExpenseTypeOptions({
                  categories: get(this.state, "claimPolicy.category", []),
                })}
                getOptionLabel={(option) => option.subcategoryname}
                getOptionValue={(option) => option.subexpensesubcategoryid}
                onChange={(e) => this.onSelectSubCategory(e)}
                value={this.state.selectedSubCategory}
              />
            </div>

            {selectedSubCategory && obj && obj.expenserequestfield && obj.expenserequestfield.length > 0 && (
              <DynamicForm
                outputconverter={outputconverter}
                fields={inputconverter({
                  arr: get(obj, "expenserequestfield", []),
                  categorylimit: catobj && catobj.isexceptionallowed
                    ? claimPolicy && claimPolicy.isexceptionallowed
                      ? null : claimPolicy.policylimit
                    : catobj.categorylimit
                      ? catobj.categorylimit : null,
                  ispolicylimit: catobj && catobj.isexceptionallowed && claimPolicy && !claimPolicy.isexceptionallowed ? true : false,
                })}
                formKey={selectedcount}
              />
            )}

            {selectedSubCategory && (
              <div style={{ height: 100 }}>
                {obj
                  && obj.attachmenturl
                  && obj.attachmenturl.length > 0
                  && obj.attachmenturl.map((img, imgindex) => (
                    <div key="img" className="add-attachment">
                      <img src={this.getFormattedImageLink(img) || walletIcon} className="expense-attachment-img" />
                      <img src={cancelIcon} style={{ zIndex: 0 }} className="remove-attachment-icon" onClick={() => this.removeImg(imgindex)} />
                    </div>
                  ))}
                <div className="add-attachment">
                  <ToolTip title="Insert attachment" placement="right">
                    <Dropzone
                      // onDragEnter={this.validateAction.bind(this, "logo", "img")}
                      onDrop={this.getFiles1.bind(this)}
                      // onFileDialogCancel={this.onCancel.bind(this)}
                      multiple={false}
                      accept="image/gif, image/jpeg, image/png, image/jpg, .pdf"
                      // style={thumb}
                      maxSize={5000000}
                      className="drag-drop"
                    >
                      <Add className="add-attachement-icon" />
                    </Dropzone>
                  </ToolTip>
                </div>
                <div className="clear-float"> </div>
                <p className="input-label">
                  Note:<br></br>
                    Supported files: .gif, .jpeg, .jpg, .pdf and .png<br></br>
                    Max size: 5MB
                </p>
              </div>
            )}
            {selectedSubCategory && (
              <div className="action-btn-group clear-float">
                <Button color="primary" variant="contained" className="delete-btn" onClick={this.onDeleteExpenseDetails}>
                  Delete
                </Button>
                <Button color="primary" variant="contained" className="primary-btn" onClick={() => this.onAdd(false)}>
                  Add
                </Button>
              </div>
            )}
          </Paper>
        )}
        {!this.state.afteradd && (
          <div>
             <div>
              <DynamicForm
                fields={selectinputconverter({
                  value: this.state.currencyconversionlogid,
                  options: this.state.currencyList,
                  label: "Currency",
                  placeholder: "Select currency",
                  disabled: this.state.postdata.expenserequestdetail.length > 0,
                })}
                onChange={(e) => this.handleChange(e, "currencyconversionlogid")}
              />
            </div>
            {postdata.expenserequestdetail.map((expensedetail) => {
              const billdate = expensedetail && expensedetail.expenserequestfield.find((field) => field.defaultfieldtypeid == 1);
              const billamount = expensedetail && expensedetail.expenserequestfield.find((field) => field.defaultfieldtypeid == 2);
              const merchantname = expensedetail && expensedetail.expenserequestfield.find((field) => field.defaultfieldtypeid == 3);
              const sentobj = {
                count: expensedetail && expensedetail.count,
                subcategoryname: expensedetail && expensedetail.subcategoryname,
                subexpensecategoryid: expensedetail && expensedetail.subexpensecategoryid,
                subexpensesubcategoryid: expensedetail && expensedetail.subexpensesubcategoryid,
              };
              return (
                <Paper key="e" className="drawer-container cursour-pointer" onClick={() => this.getSubCategory(sentobj)}>
                  <Grid container>
                    <Grid item xs={12} md={1} sm={1}>
                      <span className="icon-with-label">
                        <img src={walletIcon} alt="category-icon" height="16" />
                      </span>
                    </Grid>
                    <Grid item xs={12} md={6} sm={6}>
                      <span className="expense-selected-list-data t-bold">{expensedetail && expensedetail.subcategoryname}</span>
                      <span className="expense-selected-list-data margin-top-8">{merchantname && merchantname.value}</span>
                    </Grid>
                    <Grid item xs={12} md={5} sm={5}>
                      <span className="expense-selected-list-data text-align-right t-bold">
                        {billamount && `${this.state.selectedcurrency && this.state.selectedcurrency.currencycode}${" "} ${billamount.value}`}
                      </span>
                      <span className="expense-selected-list-data text-align-right margin-top-8">{getFormattedDate(billdate && billdate.value)}</span>
                    </Grid>
                  </Grid>
                </Paper>
              );
            })}
            <Paper style={{ cursor: "pointer", padding: "30px 16px", textAlign: "center", border: "1px dashed #1e8ced" }} onClick={() => this.onAdd(true)}>
              <div className="cursour-pointer" >
                <Add
                  style={{
                    height: 16,
                    width: 16,
                    marginLeft: 8,
                    marginRight: 16,
                    position: "relative",
                    top: 3,
                    borderRadius: 16,
                    background: "#1e8ced",
                    color: "#fff",
                  }}
                />
                <span style={{ color: "#1e8ced", fontSize: 14, fontWeight: "bold" }}>Add expense</span>
              </div>
            </Paper>
            {this.state.copydata.expenserequestdetail.length > 0 && (
              <div>
                <div style={{ color: 'red', fontSize: 14, margin: '16px 0px' }}>{errmsg1}</div>
                <Button color="primary" variant="contained" className="margin-top-40"
                disabled={!this.state.isSendRequestBtn}
                onClick={this.onSave}>
                  Send Request
                </Button>
              </div>
            )}
          </div>
        )}
      </div>
      }
      </div>
    );
  }
}
